import { useState } from "react";
import { useCases } from "../useCases";
import { CaseDetails } from "./CaseDetails";
import StatusIcon from "../ui/StatusIcon.jsx";

export function CasesList({ practiceSlug }) {
  const [offset, setOffset] = useState(null);
  const [filterEmail, setFilterEmail] = useState(null);
  const [caseToView, setCaseToView] = useState(null);
  const { isLoadingCases, cases, nextOffset, practiceUsersEmails, error } =
    useCases({
      practiceSlug,
      filterEmail,
      offset,
    });

  if (isLoadingCases) {
    return <div>Loading cases...</div>;
  }

  if (error) {
    return <div>Error loading cases: {error.message}</div>;
  }

  return (
    <div>
      {practiceUsersEmails.length > 1 && (
        <div className="filter-container">
          <label className="flex-none" htmlFor="filter-email">
            Filter by:
          </label>
          <select
            id="filter-email"
            value={filterEmail || ""}
            onChange={(e) => {
              setFilterEmail(e.target.value || null);
              setOffset(null); // Reset pagination when filter changes
            }}
          >
            <option value="">All Users</option>
            {practiceUsersEmails.map((email) => (
              <option key={email} value={email}>
                {email}
              </option>
            ))}
          </select>
        </div>
      )}
      <CaseDetails caseData={caseToView} setCaseToView={setCaseToView} />
      <div
        className={`table-overflow${
          practiceUsersEmails.length > 1 ? " show-submitted-by" : ""
        }`}
      >
        <table className="cases-table" data-cy="cases-table">
          <thead>
            <tr>
              <th>Pet Name</th>
              <th>Species</th>
              <th>Owner Name</th>
              <th>Aquamation Type</th>
              {practiceUsersEmails.length > 1 && <th>Submitted By</th>}
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {cases.map((caseData) => (
              <tr key={caseData.id} onClick={() => setCaseToView(caseData)}>
                <td>{caseData.fields.petName} </td>
                <td>{caseData.fields.species}</td>
                <td>{caseData.fields.ownerName}</td>
                <td>{caseData.fields.aquamationType}</td>
                {practiceUsersEmails.length > 1 && (
                  <td>{caseData.fields.createdBy}</td>
                )}
                <td>
                  <StatusIcon
                    status={caseData.fields.caseStatus}
                    aquamationType={caseData.fields.aquamationType}
                    returnLogistics={caseData.fields.returnLogistics}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {nextOffset && (
          <div className="mb-3 mt-2 text-center">
            <button className="button" onClick={() => setOffset(nextOffset)}>
              Load More
            </button>
          </div>
        )}
      </div>
      {cases.length === 0 && (
        <div className="mt-2">
          No cases found. Click the new case button above to submit your first
          case.
        </div>
      )}
    </div>
  );
}
